import { memo } from 'react';
import { Color } from 'three';
import { Canvas as FiberCanvas, type CanvasProps } from '@react-three/fiber';
import { CAMERA_SETTINGS } from 'modules/editor/constants';
import { useSelector } from 'app/store';
import { settingsIsCountryRestrictedSelector } from 'modules/settings/slice';

const { defaultZoom: zoom, far } = CAMERA_SETTINGS;

function CanvasImpl({
  children,
  scene = { background: new Color(0xffffff) },
  camera = { zoom, far },
  resize = { scroll: false, debounce: { scroll: 50, resize: 0 } }, // turn off scroll listener
  ...restProps
}: CanvasProps) {
  const isRestrictedCountry = useSelector(settingsIsCountryRestrictedSelector);

  return (
    <FiberCanvas
      scene={scene}
      camera={camera}
      resize={resize}
      frameloop={isRestrictedCountry ? 'never' : 'demand'}
      orthographic
      flat
      {...restProps}
    >
      {children}
    </FiberCanvas>
  );
}

export const Canvas = memo(CanvasImpl);
